window.interdeal = {
  get sitekey() {
    return "e36afa24ca8dbd20b259a96ad148a903";
  },
  get domains() {
    return {
      js: "https://cdn.equalweb.com/",
      acc: "https://access.equalweb.com/",
    };
  },
  Position: "left",
  Menulang: "pt-PT",
  draggable: false,
  btnStyle: {
    vPosition: ["50%", "50%"],
    margin: ["0", "0"],
    scale: ["0.6", "0.5"],
    color: {
      main: "#000000",
      second: "#ffffff",
    },
    icon: {
      outline: false,
      outlineColor: "#000000",
      type: 11,
      shape: "rounded",
    },
  },
};

(function (doc, head, body) {
  var coreCall = doc.createElement("script");
  coreCall.src = interdeal.domains.js + "core/5.3.1/accessibility.js";
  coreCall.defer = true;
  coreCall.integrity =
    "sha512-3qLj5jbjMQnXk+FqEdVJjUnjJBGuBTRVOwaiT0ms6mQKQcrz4nulBxl2Hsr0/PpvEqdyJsMsU1NB+Mtfzw8hxA==";
  coreCall.crossOrigin = "anonymous";
  coreCall.setAttribute("data-cfasync", true);
  body ? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);
